import MatchedMap from 'utilities/src/matchedMap';

import { ThemeEnum, useTheme } from '../../Theme';
import { type FlyoutThemeProps } from '../types/_theme';

import flyoutCommonTheme from './common';

import flyoutBlogTheme from './_blog';
import flyoutSiteTheme from './_site';

const flyoutThemes = (args: FlyoutThemeProps) =>
  new MatchedMap([
    [ThemeEnum.Blog, flyoutBlogTheme(args)],
    [ThemeEnum.Site, flyoutSiteTheme(args)],
  ]);

const useFlyoutTheme = (args: FlyoutThemeProps) => useTheme(flyoutCommonTheme(args), flyoutThemes(args));

export default useFlyoutTheme;
